module.exports = __webpack_public_path__ + "img/property.7b8a9aae.jpeg";